import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

// Whether a feature is on/off rather than a usage quota: stored with the limit period the backend gives for on/off
// features (options.toggle_feature_limits), its limit fields hold no real limit and Enabled alone grants it.
export const is_toggle_feature = (feature, options)=>{
	return feature.limit_period === options.toggle_feature_limits.limit_period;
};

// A plan's features as rows: name with its code under it, the usage limit (On/off for an on/off feature), whether
// it is enabled, and Edit and Delete buttons that call back with the feature. options is what the backend sends
// with the plans.
function PlanFeaturesTable({features, options, on_edit, on_delete}){

	// The usage limit as read, such as 100 run per month, On/off, or No limit.
	const get_limit_text = (feature)=>{
		if(is_toggle_feature(feature, options)){
			return 'On/off';
		}

		if((feature.limit_value === null) || (feature.limit_value === undefined)){
			return 'No limit';
		}

		const value_text = String(Number(feature.limit_value));
		const type_text = feature.limit_type ? ' ' + feature.limit_type : '';
		const period_text = (feature.limit_period && (feature.limit_period !== 'none')) ? ' per ' + feature.limit_period : '';
		return value_text + type_text + period_text;
	};

	const render_row = (feature)=>{
		return (
			<Row key={feature.id} className="subscription-feature-row">
				<Col className="subscription-feature-name-col">
					{feature.name}
					<div className="subscription-feature-code">{feature.code}</div>
				</Col>
				<Col className="subscription-feature-limit-col">{get_limit_text(feature)}</Col>
				<Col className="subscription-feature-enabled-col">{feature.is_enabled ? 'Enabled' : 'Disabled'}</Col>
				<Col className="subscription-feature-actions-col">
					<Button
						className="subscription-action-button"
						variant="outline-primary"
						size="sm"
						onClick={()=>{ on_edit(feature); }}>
						Edit
					</Button>
					<Button
						className="subscription-action-button"
						variant="outline-danger"
						size="sm"
						onClick={()=>{ on_delete(feature); }}>
						Delete
					</Button>
				</Col>
			</Row>
		);
	};

	if(!features || (features.length === 0)){
		return (
			<p className="subscription-empty">No features yet.</p>
		);
	}

	return (
		<div className="subscription-features">
			<Row className="subscription-feature-header-row">
				<Col className="subscription-feature-name-col">Feature</Col>
				<Col className="subscription-feature-limit-col">Usage limit</Col>
				<Col className="subscription-feature-enabled-col">Status</Col>
				<Col className="subscription-feature-actions-col"></Col>
			</Row>
			{features.map((feature)=>{ return render_row(feature); })}
		</div>
	);
}

export default PlanFeaturesTable;
